
import { getRandNumMp, intRandom } from './_randNum';

export function motionLogo() {
  const logo = document.querySelectorAll('.motion-logo-svg');
  if(logo.length) {
    const logoInit = () => {
      for (let i = 0; i < logo.length; i++) {
        const el = logo[i];
        const path = el.querySelectorAll('use, path');
        let randoms = [];
        const min = 0;
        const max = path.length;
        for(let i = min; i <= max; i++){
          while(true){
            var tmp = intRandom(min, max);
            if(!randoms.includes(tmp)){
              randoms.push(tmp);
              break;
            }
          }
        }
        if(path) {
          for (let i = 0; i < path.length; i++) {
            const el = path[i];
            let skew = 0;
            setInterval(() => {
              if(window.innerWidth >= 768) {
                skew = getRandNumMp(0.4);
              } else {
                skew = getRandNumMp(0.7);
              }
              el.style.transform = `translateX(${skew}rem)`;
            }, 1000);
          }
        }
      }
    }
    logoInit();
  }
}